import { apiClient } from "./axios";


export interface IContent {
  imageUrl: string;
  title: string;
  content: string;
}

export interface ITuanSanResponse {
  id: string;
  articleLink: string;
  role: string;
  videoLink: string;
  contentList: IContent[];
  createdAt: string;
  updatedAt: string;
  imageQRCode: string;
  newNumber: string;
}

export const getNewsByRoleLatest = async (
  role: string,
  isNewsLatest: boolean,
  key: string
): Promise<ITuanSanResponse> => {
  if (key !== '') {
    const response = await apiClient.get<ITuanSanResponse>(
      `bulletin/role/${role}/articleLink/${key}`
    );
    return response.data;
  }
  if (isNewsLatest) {
    const response = await apiClient.get<ITuanSanResponse>(
      `bulletin/role/${role}/latest`
    );
    return response.data;
  } else {
    const response = await apiClient.get<ITuanSanResponse>(
      `bulletin/role/${role}/first`
    );
    return response.data;
  }
};

